import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { BetBarComponent } from "slotworks/components/betbar/bet-bar-component";

export function UpdateFreespinsBetbarCommand() {
    const game = gameState.getCurrentGame();

    Components.get(BetBarComponent).setTotalFreespins(game.getTotalFreespinsWon());
    Components.get(BetBarComponent).setFreespinsPlayed(Math.max(0, game.getFreespinsPlayed() + 1));
}
